module.exports = __webpack_public_path__ + "static/media/loader.dc3dca5b.svg";